import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import { colors } from '../../../../../../theme/styles';
import { goToEditSectors } from '../../../../../../router/coordinator';
import {
  HiddenForPermission,
  PaginationDesktop,
  SkeletonDesktop
} from '../../../../../../components';

export function DesktopTable({
  sectors,
  navigate,
  count,
  loading,
  page,
  offset,
  handlePage,
  handleChangeRowsPerPage
}) {
  const sectorsList = sectors.map((sector) => {
    return (
      <TableRow key={sector.uuid} className="not-effect">
        <TableCell>{sector.title?.toTitleCase()}</TableCell>
        <TableCell>{sector.acronym?.toUpperCase()}</TableCell>
        <HiddenForPermission keys="EDIT_SECTORS">
          <TableCell style={{ textAlign: 'right', color: colors.black }}>
            <IconButton onClick={() => goToEditSectors(navigate, sector.uuid)}>
              <CreateIcon />
            </IconButton>
          </TableCell>
        </HiddenForPermission>
      </TableRow>
    );
  });

  function RenderTable() {
    if (loading) {
      return <SkeletonDesktop numbersOfColumns={3} />;
    }

    return sectorsList;
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Sigla</TableCell>
              <HiddenForPermission keys="EDIT_SECTORS">
                <TableCell style={{ textAlign: 'right' }}>Editar</TableCell>
              </HiddenForPermission>
            </TableRow>
          </TableHead>
          <TableBody>
            <RenderTable />
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationDesktop
        count={count}
        page={page}
        rowsPerPage={offset}
        handlePage={handlePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  );
}
